import React, { useCallback, useState, useEffect, useMemo } from "react";
import axios from "axios";
import classNames from "classnames";
import ReactTooltip from "react-tooltip";
import { addGlobalMessage } from "../actions/globalmessages";
import { smoothScrollToTop } from "../functions";
import { useDispatch } from "react-redux";

const EndTermToggleCheckbox = ({ disabled, endTermName, checked, endTermUUID, exemptionUUID = "", toggleEndTerm }) => {
    return (
        <div className="end-term-container" key={`${endTermUUID}-${exemptionUUID}`}>
            <input disabled={disabled} type="checkbox" name={endTermName} value={true} checked={checked} onChange={() => toggleEndTerm(endTermUUID, exemptionUUID)} />
        </div>
    );
};

const EndTermToggleTableRow = ({ disabled, endTermName, checked, endTermUUID, exemptionUUID = "", toggleEndTerm }) => {
    return (
        <tr className={classNames({ inactive: !checked })}>
            <td>{endTermName}</td>
            <td width="180">
                {!disabled && (
                    <i onClick={() => toggleEndTerm(endTermUUID, exemptionUUID)} className={classNames("fa color-blue", checked ? "fa-toggle-on" : "fa-toggle-off")} />
                )}
                {disabled && (
                    <>
                        <i className="fa fa-info-circle" data-tip data-for={`tip-${exemptionUUID}-${endTermUUID}`} />
                        <ReactTooltip id={`tip-${exemptionUUID}-${endTermUUID}`} effect="solid">
                            Voor deze eindterm is er geen vrijstelling toegestaan
                        </ReactTooltip>
                    </>
                )}
            </td>
        </tr>
    );
};

export const EndTermToggle = (props) => {
    const [endTerm, setEndTerm] = useState(props.endTerm);
    const [exemption, setExemption] = useState(props?.exemption);
    const EndTermHTML = props?.type === "checkbox" ? EndTermToggleCheckbox : EndTermToggleTableRow;

    const url = `/v1/users/${props?.userUUID}/exemptions/`;
    const disabledFunction = typeof props.disabled === 'function' ? props.disabled : () => false;
    const disabled = useMemo(() => !endTerm?.can_be_exempted || props.isCancelled || disabledFunction(), [endTerm, props.isCancelled, props.disabled]);
    const dispatch = useDispatch();

    const toggleEndTerm = useCallback(
        async (endTermUUID, exemptionUUID = false) => {
            try {
                if (!exemptionUUID) {
                    const exemption = await axios.post(url, {
                        competence_profile: props?.competenceProfileUUID,
                        course: props?.courseUUID,
                        end_term: endTermUUID
                    });
                    setExemption(exemption?.data);
                } else {
                    await axios.delete(url + `${exemptionUUID}/`);
                    setExemption(false);
                }

                if (typeof props?.onSuccess === "function") {
                    props.onSuccess();
                }
            } catch (error) {
                if (error?.response?.data?.detail?.includes("Unable to remove this exemption")) {
                    dispatch(
                        addGlobalMessage({
                            title: "Unable to remove this exemption because there are already measurement results created by it!",
                            type: "error",
                            icon: "fa fa-exclamation-triangle"
                        })
                    );
                    smoothScrollToTop(600);
                }
                console.log(error);
            }
        },
        [props?.competenceProfileUUID, props?.courseUUID]
    );

    // It is possible the props change due to external behaviour. If so, we should update accordingly
    useEffect(() => {
        setEndTerm(props?.endTerm);
        setExemption(props?.exemption);
    }, [props?.endTerm?.uuid, props?.exemption?.uuid]);

    return (
        <EndTermHTML
            disabled={disabled}
            endTermName={endTerm?.name}
            checked={!!exemption}
            endTermUUID={endTerm?.uuid}
            exemptionUUID={exemption?.uuid}
            toggleEndTerm={toggleEndTerm}
        />
    );
};
